import { render, staticRenderFns } from "./PropertyBlock.vue?vue&type=template&id=52bdb67d&scoped=true&"
import script from "./PropertyBlock.vue?vue&type=script&lang=ts&"
export * from "./PropertyBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bdb67d",
  null
  
)

export default component.exports